import apiService from '@/services/api.service'
import type { FeatureFlag } from './feature-flags'

interface FeatureFlagItem {
  name: string
  active: boolean
}

interface FeatureFlagsResponse {
  flags: FeatureFlagItem[]
}

type FeatureFlagsMap = Partial<Record<FeatureFlag, boolean>>

/**
 * Fetches feature flags from the backend.
 * Returns an empty map on error or invalid response (fail-closed).
 * Does NOT mutate the store directly.
 */
export const fetchFeatureFlags = async (): Promise<FeatureFlagsMap> => {
  try {
    const response =
      await apiService.apiClient.get<FeatureFlagsResponse>('/feature-flags')

    if (!response.data?.flags || !Array.isArray(response.data.flags)) {
      return {}
    }

    return normalizeFlags(response.data.flags)
  } catch {
    return {}
  }
}

/**
 * Validates and normalizes the response into a map usable by the store.
 */
const normalizeFlags = (flags: FeatureFlagItem[]): FeatureFlagsMap => {
  const normalized: Record<string, boolean> = {}

  for (const flag of flags) {
    if (typeof flag.name === 'string' && typeof flag.active === 'boolean') {
      normalized[flag.name] = flag.active
    }
  }

  return normalized
}

export default {
  fetchFeatureFlags,
}
